import { MembershipModel } from './membership.model';

export class UserModel {
    id: number;
    affiliate_id: string;
    email: string;
    password: string;
    name: string;
    telephone: string;
    city: string;
    shortName: string;
    loginType: string;
    team: string;
    gender: string;
    birthday: string;
    memberships: MembershipModel[] = [];
    constructor(user?: any) {

        if (user) {
            this.id = user.id;
            this.affiliate_id = user.affiliate_id;
            this.shortName = user.name.split(" ")[0];
            this.name = user.name;
            this.email = user.email;
            this.telephone = user.telephone;
            this.city = user.city;
            this.loginType = user.login_type;
            this.team = user.team;
            this.gender = user.gender;
            this.birthday = user.birthday;
        }

    }

    public hasValidMembership(id: number = 0) {
        for (const i in this.memberships) {
            if (id === this.memberships[i].id && this.memberships[i].isValid) {
                return true;
            }
        }
        return false;
    }

    public hasMembership(id: number = 0): boolean {
        for (const i in this.memberships) {
            if (id === this.memberships[i].id) {
                return true;
            }
        }
        return false;
    }

    public get hasOneValidMembership(): boolean {
        for (const i in this.memberships) {
            if (this.memberships[i].isValid) {
                return true;
            }
        }
        return false;
    }

    public get isLogged(): boolean {
        return this.id != null && this.id != 0 ? true : false;
    }
}